/**
 * API base URL for axios calls.
 * - REACT_APP_API_URL: explicit override (any environment).
 * - Production build with no env: same origin + /api (behind reverse proxy).
 * - Development: default http://localhost:4000
 */
export function getApiBase() {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv != null && String(fromEnv).trim() !== "") {
    return String(fromEnv).replace(/\/$/, "");
  }
  if (
    typeof window !== "undefined" &&
    window.location &&
    process.env.NODE_ENV === "production"
  ) {
    return `${window.location.origin}/api`;
  }
  return "http://localhost:4000";
}
